/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-CMS Popup API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { PopupCodeTriggerRestDto } from '../models';
import { PopupTimeDelayTriggerRestDto } from '../models';
import { PopupTriggerOverviewResultsRestDto } from '../models';
/**
 * PopupTriggerEndpointsApi - axios parameter creator
 * @export
 */
export const PopupTriggerEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Note that there is only one exit intent trigger per popup allowed.
         * @summary REST.API.CMS.POPET.01 Create a new popup exit intent trigger.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExitIntentDelayTrigger: async (popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling createExitIntentDelayTrigger.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/exit_intent_trigger`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.01 Create a new popup code trigger.
         * @param {PopupCodeTriggerRestDto} body 
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopupCodeTrigger: async (body: PopupCodeTriggerRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPopupCodeTrigger.');
            }
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling createPopupCodeTrigger.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/code_trigger`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPTT.01 Create a new popup time delay trigger.
         * @param {PopupTimeDelayTriggerRestDto} body 
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPopupTimeDelayTrigger: async (body: PopupTimeDelayTriggerRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createPopupTimeDelayTrigger.');
            }
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling createPopupTimeDelayTrigger.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/time_delay_trigger`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.04 Delete popup code trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopupCodeTrigger: async (trigger_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trigger_id' is not null or undefined
            if (trigger_id === null || trigger_id === undefined) {
                throw new RequiredError('trigger_id','Required parameter trigger_id was null or undefined when calling deletePopupCodeTrigger.');
            }
            const localVarPath = `/popup/v1/code_trigger/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(trigger_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes the one and only popup exit intent trigger
         * @summary REST.API.CMS.POPET.02 Delete popup exit intent trigger.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopupExitIntentTrigger: async (popup_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling deletePopupExitIntentTrigger.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/exit_intent_trigger`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.04 Delete popup code trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePopupTimeDelayTrigger: async (trigger_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trigger_id' is not null or undefined
            if (trigger_id === null || trigger_id === undefined) {
                throw new RequiredError('trigger_id','Required parameter trigger_id was null or undefined when calling deletePopupTimeDelayTrigger.');
            }
            const localVarPath = `/popup/v1/time_delay_trigger/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(trigger_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.02 Get popup code trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupCodeTrigger: async (trigger_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trigger_id' is not null or undefined
            if (trigger_id === null || trigger_id === undefined) {
                throw new RequiredError('trigger_id','Required parameter trigger_id was null or undefined when calling getPopupCodeTrigger.');
            }
            const localVarPath = `/popup/v1/code_trigger/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(trigger_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPTT.02 Get popup time delay trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupTimeDelayTrigger: async (trigger_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'trigger_id' is not null or undefined
            if (trigger_id === null || trigger_id === undefined) {
                throw new RequiredError('trigger_id','Required parameter trigger_id was null or undefined when calling getPopupTimeDelayTrigger.');
            }
            const localVarPath = `/popup/v1/time_delay_trigger/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(trigger_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPT.01 Get an overview of the popup triggers.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPopupTriggerOverview: async (popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'popup_id' is not null or undefined
            if (popup_id === null || popup_id === undefined) {
                throw new RequiredError('popup_id','Required parameter popup_id was null or undefined when calling getPopupTriggerOverview.');
            }
            const localVarPath = `/popup/v1/popup/{popup_id}/trigger`
                .replace(`{${"popup_id"}}`, encodeURIComponent(String(popup_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            if (x_dp_language !== undefined && x_dp_language !== null) {
                localVarHeaderParameter['x-dp-language'] = String(x_dp_language);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.03 Update popup code trigger.
         * @param {PopupCodeTriggerRestDto} body 
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopupCodeTrigger: async (body: PopupCodeTriggerRestDto, trigger_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePopupCodeTrigger.');
            }
            // verify required parameter 'trigger_id' is not null or undefined
            if (trigger_id === null || trigger_id === undefined) {
                throw new RequiredError('trigger_id','Required parameter trigger_id was null or undefined when calling updatePopupCodeTrigger.');
            }
            const localVarPath = `/popup/v1/code_trigger/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(trigger_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.03 Update popup time delay trigger.
         * @param {PopupTimeDelayTriggerRestDto} body 
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePopupTimeDelayTrigger: async (body: PopupTimeDelayTriggerRestDto, trigger_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updatePopupTimeDelayTrigger.');
            }
            // verify required parameter 'trigger_id' is not null or undefined
            if (trigger_id === null || trigger_id === undefined) {
                throw new RequiredError('trigger_id','Required parameter trigger_id was null or undefined when calling updatePopupTimeDelayTrigger.');
            }
            const localVarPath = `/popup/v1/time_delay_trigger/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(trigger_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PopupTriggerEndpointsApi - functional programming interface
 * @export
 */
export const PopupTriggerEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Note that there is only one exit intent trigger per popup allowed.
         * @summary REST.API.CMS.POPET.01 Create a new popup exit intent trigger.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExitIntentDelayTrigger(_axios: AxiosInstance, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).createExitIntentDelayTrigger(popup_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.01 Create a new popup code trigger.
         * @param {PopupCodeTriggerRestDto} body 
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPopupCodeTrigger(_axios: AxiosInstance, body: PopupCodeTriggerRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).createPopupCodeTrigger(body, popup_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPTT.01 Create a new popup time delay trigger.
         * @param {PopupTimeDelayTriggerRestDto} body 
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPopupTimeDelayTrigger(_axios: AxiosInstance, body: PopupTimeDelayTriggerRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).createPopupTimeDelayTrigger(body, popup_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.04 Delete popup code trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePopupCodeTrigger(_axios: AxiosInstance, trigger_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).deletePopupCodeTrigger(trigger_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Deletes the one and only popup exit intent trigger
         * @summary REST.API.CMS.POPET.02 Delete popup exit intent trigger.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePopupExitIntentTrigger(_axios: AxiosInstance, popup_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).deletePopupExitIntentTrigger(popup_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.04 Delete popup code trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePopupTimeDelayTrigger(_axios: AxiosInstance, trigger_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).deletePopupTimeDelayTrigger(trigger_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.02 Get popup code trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopupCodeTrigger(_axios: AxiosInstance, trigger_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopupCodeTriggerRestDto>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).getPopupCodeTrigger(trigger_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPTT.02 Get popup time delay trigger.
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopupTimeDelayTrigger(_axios: AxiosInstance, trigger_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopupTimeDelayTriggerRestDto>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).getPopupTimeDelayTrigger(trigger_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPT.01 Get an overview of the popup triggers.
         * @param {string} popup_id Uniquely identifies the popup.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPopupTriggerOverview(_axios: AxiosInstance, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PopupTriggerOverviewResultsRestDto>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).getPopupTriggerOverview(popup_id, x_dp_customer_code, x_dp_language, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.03 Update popup code trigger.
         * @param {PopupCodeTriggerRestDto} body 
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePopupCodeTrigger(_axios: AxiosInstance, body: PopupCodeTriggerRestDto, trigger_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).updatePopupCodeTrigger(body, trigger_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.CMS.POPCT.03 Update popup time delay trigger.
         * @param {PopupTimeDelayTriggerRestDto} body 
         * @param {string} trigger_id Uniquely identifies the popup trigger.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePopupTimeDelayTrigger(_axios: AxiosInstance, body: PopupTimeDelayTriggerRestDto, trigger_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PopupTriggerEndpointsApiAxiosParamCreator(configuration).updatePopupTimeDelayTrigger(body, trigger_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PopupTriggerEndpointsApi - object-oriented interface
 * @export
 * @class PopupTriggerEndpointsApi
 * @extends {BaseAPI}
 */
export class PopupTriggerEndpointsApi extends BaseAPI {
    /**
     * Note that there is only one exit intent trigger per popup allowed.
     * @summary REST.API.CMS.POPET.01 Create a new popup exit intent trigger.
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public createExitIntentDelayTrigger(popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).createExitIntentDelayTrigger(this.axios, popup_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCT.01 Create a new popup code trigger.
     * @param {PopupCodeTriggerRestDto} body 
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public createPopupCodeTrigger(body: PopupCodeTriggerRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).createPopupCodeTrigger(this.axios, body, popup_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPTT.01 Create a new popup time delay trigger.
     * @param {PopupTimeDelayTriggerRestDto} body 
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public createPopupTimeDelayTrigger(body: PopupTimeDelayTriggerRestDto, popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).createPopupTimeDelayTrigger(this.axios, body, popup_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCT.04 Delete popup code trigger.
     * @param {string} trigger_id Uniquely identifies the popup trigger.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public deletePopupCodeTrigger(trigger_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).deletePopupCodeTrigger(this.axios, trigger_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes the one and only popup exit intent trigger
     * @summary REST.API.CMS.POPET.02 Delete popup exit intent trigger.
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public deletePopupExitIntentTrigger(popup_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).deletePopupExitIntentTrigger(this.axios, popup_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCT.04 Delete popup code trigger.
     * @param {string} trigger_id Uniquely identifies the popup trigger.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public deletePopupTimeDelayTrigger(trigger_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).deletePopupTimeDelayTrigger(this.axios, trigger_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCT.02 Get popup code trigger.
     * @param {string} trigger_id Uniquely identifies the popup trigger.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public getPopupCodeTrigger(trigger_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).getPopupCodeTrigger(this.axios, trigger_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPTT.02 Get popup time delay trigger.
     * @param {string} trigger_id Uniquely identifies the popup trigger.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public getPopupTimeDelayTrigger(trigger_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).getPopupTimeDelayTrigger(this.axios, trigger_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPT.01 Get an overview of the popup triggers.
     * @param {string} popup_id Uniquely identifies the popup.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {string} [x_dp_language] Indicates in which language the product information is expected. (Fallback to default language for customer if not provided.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public getPopupTriggerOverview(popup_id: string, x_dp_customer_code?: string|null, x_dp_language?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).getPopupTriggerOverview(this.axios, popup_id, x_dp_customer_code, x_dp_language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCT.03 Update popup code trigger.
     * @param {PopupCodeTriggerRestDto} body 
     * @param {string} trigger_id Uniquely identifies the popup trigger.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public updatePopupCodeTrigger(body: PopupCodeTriggerRestDto, trigger_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).updatePopupCodeTrigger(this.axios, body, trigger_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.CMS.POPCT.03 Update popup time delay trigger.
     * @param {PopupTimeDelayTriggerRestDto} body 
     * @param {string} trigger_id Uniquely identifies the popup trigger.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Menu Endpoints
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PopupTriggerEndpointsApi
     */
     public updatePopupTimeDelayTrigger(body: PopupTimeDelayTriggerRestDto, trigger_id: string, x_dp_customer_code?: string|null, options?: any) {
        return PopupTriggerEndpointsApiFp(this.configuration).updatePopupTimeDelayTrigger(this.axios, body, trigger_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
